import { makeStyles } from "@material-ui/core/styles";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import DeleteIcon from "@material-ui/icons/Delete";
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import { useState } from "react";
import { checkUser } from "../../../../../../../../common/util/User/checkUser";
import { MuteUserOutlinedIcon } from "../../../../../../../../icon/MuteUserOutlinedIcon";
import { fetchSetMuteStatus } from "../../../../../../Message/MessagePanel/components/fetchSetMuteStatus";
import { Post } from "../../../types";

export function LowerButtonArea({
    post,
    userId,
    tmpMutedUserIds,
    setTmpMutedUserIds,
    isMyPost,
    deletePost,
    likePost,
    unlikePost,
    hideButtonTitle,
}: {
    post: Post;
    userId: number;
    tmpMutedUserIds: number[];
    setTmpMutedUserIds: (ids: number[]) => void;
    isMyPost: boolean;
    deletePost: () => Promise<void>;
    likePost: () => Promise<void>;
    unlikePost: () => Promise<void>;
    hideButtonTitle?: boolean;
}) {
    const c = useStyles();
    const [submitting, setSubmitting] = useState(false);

    return (
        <div className={c.container}>
            <div className={c.comment}>
                <ChatBubbleOutlineIcon className={c.commentIcon} />
                {post.commentCount > 0
                    ? post.commentCount.toLocaleString()
                    : !hideButtonTitle && "Comment"}
            </div>

            <LikeButton
                post={post}
                likePost={likePost}
                unlikePost={unlikePost}
                hideButtonTitle={hideButtonTitle}
            />

            {isMyPost ? (
                <div
                    className={c.delete}
                    onClick={async ev => {
                        ev.stopPropagation();
                        if (submitting || !checkUser()) {
                            return;
                        }
                        setSubmitting(true);
                        await deletePost();
                        setSubmitting(false);
                    }}
                >
                    <DeleteIcon className={c.deleteIcon} />
                    {!hideButtonTitle && "Delete"}
                </div>
            ) : (
                <div
                    className={c.mute}
                    onClick={async ev => {
                        ev.stopPropagation();
                        if (submitting || !checkUser()) {
                            return;
                        }
                        setSubmitting(true);
                        setTmpMutedUserIds(tmpMutedUserIds.concat(post.userId));
                        await fetchSetMuteStatus(userId, post.userId, true);
                        setSubmitting(false);
                    }}
                >
                    <MuteUserOutlinedIcon className={c.muteIcon} />
                    {!hideButtonTitle && "Mute"}
                </div>
            )}
        </div>
    );
}
const useStyles = makeStyles(theme => ({
    container: {
        display: "flex",
        justifyContent: "space-between",
        color: theme.palette.grey[700],
        fontSize: "small",
        paddingRight: 5,
    },
    comment: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
    },
    commentIcon: { marginRight: 5 },
    delete: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
    },
    deleteIcon: { marginRight: 5 },
    mute: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
    },
    muteIcon: { marginRight: 5 },
}));

function LikeButton({
    post: { likeCount, ownLike },
    likePost,
    unlikePost,
    hideButtonTitle,
}: {
    post: Post;
    likePost: () => Promise<void>;
    unlikePost: () => Promise<void>;
    hideButtonTitle?: boolean;
}) {
    const [submitting, setSubmitting] = useState(false);
    const c = useLikeStyles();

    return (
        <div
            className={c.like}
            onClick={async ev => {
                ev.stopPropagation();
                if (submitting || !checkUser()) {
                    return;
                }

                setSubmitting(true);
                if (ownLike) {
                    await unlikePost();
                } else {
                    await likePost();
                }
                setSubmitting(false);
            }}
        >
            <div className={submitting ? c.sizeChangeAnime : undefined}>
                {ownLike ? (
                    <FavoriteIcon className={c.likedFavoriteIcon} />
                ) : (
                    <FavoriteBorderIcon className={c.favoriteIcon} />
                )}
            </div>
            {likeCount > 0
                ? likeCount.toLocaleString()
                : !hideButtonTitle && "Like"}
        </div>
    );
}
const useLikeStyles = makeStyles({
    like: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        height: 22.5,
    },
    likedFavoriteIcon: { marginRight: 5, color: "red" },
    favoriteIcon: { marginRight: 5 },
    sizeChangeAnime: {
        animation: "$sizeChange 1s",
        animationIterationCount: "infinite",
    },
    "@keyframes sizeChange": {
        "0%": {
            transform: "scale(1)",
        },
        "30%": {
            transform: "scale(1.2)",
        },
        "100%": {
            transform: "scale(1)",
        },
    },
});
